import { render, staticRenderFns } from "./OptimizeBroadcast.vue?vue&type=template&id=7af4f070&scoped=true&"
import script from "./OptimizeBroadcast.vue?vue&type=script&lang=js&"
export * from "./OptimizeBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./OptimizeBroadcast.vue?vue&type=style&index=0&id=7af4f070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af4f070",
  null
  
)

export default component.exports